export function isCaseInCorrectModule(caseRecord, statuses) {
  if (!caseRecord?.caseStatusId) {
    return true;
  }

  return statuses.includes(caseRecord?.caseStatusId);
}
